import * as React from 'react';
import { DateUtils } from '@grandvisionhq/utils';

const useShouldRequestAlternativeStoreSuggestions = (timeSlots, selectedData, selectedStore, timeSlotsMetadata)=>{
    return React.useMemo(()=>{
        var ref;
        const dateString = selectedData ? DateUtils.toLocalDateTime(selectedData) : '';
        const timeSlotsLoaded = timeSlots.called && !timeSlots.loading;
        const noTimeSlots = !(timeSlots.filtered.included.length > 0);
        const noOtherTimeSlots = !(timeSlots.filtered.excluded.length > 0);
        const timeslotsReferToSelectedDate = ((ref = timeSlotsMetadata === null || timeSlotsMetadata === void 0 ? void 0 : timeSlotsMetadata.timeSlotsReferTo.date) === null || ref === void 0 ? void 0 : ref.split('T')[0]) === dateString.split('T')[0];
        const timeslotsReferToSelectedStore = (timeSlotsMetadata === null || timeSlotsMetadata === void 0 ? void 0 : timeSlotsMetadata.timeSlotsReferTo.store) === (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code);
        // if there is no availability for the selected date we auto expand the alternative stores
        return timeSlotsLoaded && timeslotsReferToSelectedDate && timeslotsReferToSelectedStore && noTimeSlots && noOtherTimeSlots;
    }, [
        selectedData,
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code,
        timeSlots.called,
        timeSlots.filtered,
        timeSlots.loading,
        timeSlotsMetadata === null || timeSlotsMetadata === void 0 ? void 0 : timeSlotsMetadata.timeSlotsReferTo.date,
        timeSlotsMetadata === null || timeSlotsMetadata === void 0 ? void 0 : timeSlotsMetadata.timeSlotsReferTo.store, 
    ]);
};
var useShouldRequestAlternativeStoreSuggestions$1 = useShouldRequestAlternativeStoreSuggestions;

export { useShouldRequestAlternativeStoreSuggestions$1 as default };
//# sourceMappingURL=useShouldRequestAlternativeStoreSuggestions.js.map
